// extracted by mini-css-extract-plugin
module.exports = {"root":"image-message-module--root--1xZ4x","img":"image-message-module--img--1R8AU"};